import { render, staticRenderFns } from "./OddsTitle.vue?vue&type=template&id=9b24be10"
import script from "./OddsTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./OddsTitle.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports